import styled from "styled-components";

const StyledPublicLayout = styled.div`
  height: 100dvh;
  width: 100%;
`;

export { StyledPublicLayout };
